import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { AIEventsInstrumentationContext } from '../context';
import { defaultAIEventsInstrumentationConfigValues } from '../context/model';
import { useAIInstrumentationSetup } from '../hooks';
var validateAIEventsConfig = function validateAIEventsConfig(config) {
  if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) {
    // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
  }
};
export var AIEventsInstrumentationProvider = function AIEventsInstrumentationProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  var _useAIInstrumentation = useAIInstrumentationSetup(config.singleInstrumentationID),
    refreshSingleInstrumentationID = _useAIInstrumentation.refreshSingleInstrumentationID,
    getSingleInstrumentationID = _useAIInstrumentation.getSingleInstrumentationID,
    setAISessionState = _useAIInstrumentation.setAISessionState,
    getAISessionState = _useAIInstrumentation.getAISessionState;
  var contextValue = useMemo(function () {
    validateAIEventsConfig(config);
    return {
      config: _objectSpread(_objectSpread(_objectSpread({}, defaultAIEventsInstrumentationConfigValues), config), {}, {
        product: config.product.toLowerCase()
      }),
      refreshSingleInstrumentationID: refreshSingleInstrumentationID,
      getSingleInstrumentationID: getSingleInstrumentationID,
      setAISessionState: setAISessionState,
      getAISessionState: getAISessionState
    };
  }, [config, refreshSingleInstrumentationID, getSingleInstrumentationID, setAISessionState, getAISessionState]);
  return /*#__PURE__*/React.createElement(AIEventsInstrumentationContext.Provider, {
    value: contextValue
  }, children);
};